<template>
  <div class="about">
    <h1>A Site for Events to better the world.</h1>
    <h2>Built entirely with Vue.js</h2>
  </div>
</template>
